import { Form, getIn } from "formik";
import _ from "lodash";
import cloneDeep from "lodash/cloneDeep";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Select from "react-select";

import { DashboardCard2 } from "@/ui2/molecules/DashboardCard2";

import { api } from "../../../APIRequests";
import { CustomForm } from "../../../component-library/CustomForm";
import PracticeDetails from "../../../components/Admin/Practice/PracticeDetails";
import ProviderList from "../../../components/Admin/Practice/ProviderList";
import Button from "../../../components/UI/Button";
import FormikInput from "../../../components/UI/FormikInput";
import FormikMobileInput from "../../../components/UI/formikMobileInput";
import InputError from "../../../components/UI/InputError";
import Label from "../../../components/UI/Label";
import { adminRoute } from "../../../config/roles";
import { setDynamicRouteConfiguration } from "../../../redux/actions/navbar";
import { getAutomationDataAttr } from "../../../utils/automationUtils";
import PatientsList from "../Providers/PatientsList/PatientsList";

import {
  PRACTICE_INITIAL_VALUES,
  PRACTICE_SCHEMA,
  PRACTICE_VALIDATION_SCHEMA,
} from "./schema/editPracticeSchema";

class Practice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultPCPOptions: [],
      existingIntakeProviders: [],
      intakeProviderOptions: [],
      patientList: null,
      practiceDetails: null,
      practiceId: this.props.match.params.practiceId,
      practiceSchema: cloneDeep(PRACTICE_SCHEMA),
    };
  }

  async componentDidMount() {
    await this.getPractice();
    this.getProviderList();
    this.getPatientList();
    this.getIntakeProviders();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.practiceId !== this.props.match.params.practiceId) {
      this.setState({ practiceId: this.props.match.params.practiceId }, () =>
        this.componentDidMount(),
      );
    }
  }

  componentWillUnmount() {
    this.props.setDynamicRouteConfiguration({});
  }

  async getPractice() {
    let urlParams = { practiceId: this.state.practiceId };
    let cleanResponse = await api.shared.fetch_practice({ urlParams });

    cleanResponse.practice_specialization = this.extractLabel(cleanResponse);
    this.setState({
      practiceDetails: cleanResponse,
    });
  }

  getProviderList() {
    (async () => {
      let urlParams = { practiceId: this.state.practiceId };
      let data = { enrich_data: true };
      let providerList = await api.admin.fetch_practice_providers({ data, urlParams });

      const defaultPCPOptions = providerList
        .filter((provider) => provider["provider_type"] === "PCP")
        .map((provider) => {
          return {
            display: provider["name"],
            value: provider["username"],
          };
        });
      const practiceSchema = [...this.state.practiceSchema];

      practiceSchema.find((element) => element.name === "default_pcp_id").elementConfig.options =
        defaultPCPOptions;
      this.setState({
        defaultPCPOptions: defaultPCPOptions,
        practiceSchema: practiceSchema,
        providerList: providerList,
      });
    })();
  }

  getPatientList() {
    (async () => {
      let urlParams = { practiceId: this.state.practiceId };
      let cleanResponse = await api.admin.fetch_patient_list({ urlParams });

      this.setState({
        patientList: cleanResponse.user,
      });
    })();
  }

  getIntakeProviders() {
    (async () => {
      const queryParams = { providerTypes: "BEHAVIORAL_INTAKE" };

      try {
        const response = await api.admin.fetch_providers({ queryParams });
        const intakeProviderOptions = response.map((provider) => {
          return {
            label: provider["name"] + " - " + provider["practice"],
            value: provider["username"],
          };
        });
        const existingIntakeProviders = intakeProviderOptions.filter(
          (option) =>
            Object.hasOwn(this.state.practiceDetails, "intake_provider_ids") &&
            this.state.practiceDetails["intake_provider_ids"].includes(option.value),
        );

        this.setState({ existingIntakeProviders, intakeProviderOptions });
      } catch (e) {
        console.log(e);
      }
    })();
  }

  editButtonHandler = () => {
    this.setState((ps) => {
      return { editPracticeDetails: !ps.editPracticeDetails };
    });
  };

  setHcpAndSpmiForPracticeObject = (formData) => {
    let newFormData = _.cloneDeep(formData);

    if ("practice_specialization" in newFormData) {
      const specialization = newFormData.practice_specialization;

      if (specialization.toLowerCase() === "hcp") {
        newFormData.hcp_searchable = true;
        newFormData.is_spmi = false;
      } else if (specialization.toLowerCase() === "spmi") {
        newFormData.hcp_searchable = false;
        newFormData.is_spmi = true;
      } else if (specialization.toLowerCase() === "none" || _.isNil(specialization)) {
        newFormData.hcp_searchable = false;
        newFormData.is_spmi = false;
      }

      delete newFormData.practice_specialization;
    }

    return newFormData;
  };

  extractLabel = (practiceDetails) => {
    if (practiceDetails.is_spmi) {
      return "SPMI";
    } else if (practiceDetails.hcp_searchable) {
      return "HCP";
    }

    return "None";
  };

  submitHandler = async (formData, actions) => {
    actions.setSubmitting(false);
    const data = { ...formData };

    data["intake_provider_ids"] = data["intake_provider_ids"]
      ? data["intake_provider_ids"].map((option) => (option.value ? option.value : option))
      : [];
    const queryParams = { practiceId: this.state.practiceId };
    const updatedData = this.setHcpAndSpmiForPracticeObject(data);

    api.admin
      .update_practice({ data: updatedData, queryParams })
      .then(() => {
        const existingIntakeProviders = this.state.intakeProviderOptions.filter(
          (option) =>
            Object.hasOwn(updatedData, "intake_provider_ids") &&
            updatedData["intake_provider_ids"].includes(option.value),
        );

        // Make sure front-end and server are in sync on updatedData
        data.is_spmi = updatedData.is_spmi;
        data.hcp_searchable = updatedData.hcp_searchable;

        this.setState({ existingIntakeProviders, practiceDetails: data });
        this.editButtonHandler();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  renderForm = (formikProps) => {
    return (
      <Form>
        <div className="mx-auto px-0 mb-3">
          <div className="container px-0">
            <div className="row">
              {this.state.practiceSchema.map((formEl) => {
                const testId = `EditPracticeInfo_${formEl.name}`;

                if (formEl.elementType === "segment") {
                  return (
                    <h6 className="col-12" key={formEl.displayName}>
                      <b>{formEl.displayName}</b>
                    </h6>
                  );
                } else if (formEl.name === "phone_number") {
                  return (
                    <div className="col-12 col-lg-6" key={formEl.name}>
                      <FormikMobileInput
                        errors={formikProps.errors}
                        formEl={formEl}
                        onChange={async (val) => {
                          await formikProps.setFieldValue("phone_number", val.value);
                          formikProps.setFieldTouched("phone_number");
                        }}
                        testId={testId}
                        touched={formikProps.touched}
                        value={formikProps && formikProps.values.phone_number}
                      />
                    </div>
                  );
                } else if (formEl.name === "intake_provider_ids") {
                  const error = getIn(formikProps.errors, formEl.name);
                  const touched = getIn(formikProps.touched, formEl.name);

                  return (
                    <>
                      {this.state.practiceDetails.practice_type === "Primary Care" && (
                        <div className="col-12 col-lg-6" key={formEl.name}>
                          <Label>{formEl.elementConfig.label}</Label>
                          <Select
                            className="basic-multi-select"
                            classNamePrefix="select"
                            components={{
                              ClearIndicator: null,
                            }}
                            defaultValue={this.state.existingIntakeProviders}
                            isMulti
                            onChange={async (selectedOptions) =>
                              await formikProps.setFieldValue(formEl.name, selectedOptions)
                            }
                            options={this.state.intakeProviderOptions}
                          />
                          {error && touched ? (
                            <InputError classes="custom-error">{error}</InputError>
                          ) : null}
                        </div>
                      )}
                    </>
                  );
                } else {
                  return (
                    <div className="col-12 col-lg-6" key={formEl.name}>
                      <FormikInput
                        errors={formikProps.errors}
                        formEl={formEl}
                        testId={testId}
                        touched={formikProps.touched}
                      />
                    </div>
                  );
                }
              })}
            </div>
          </div>
        </div>

        <div className="d-lg-flex d-block tw:justify-center text-center justify-content-lg-end mb-2">
          <Button
            className="Btn Btn--otl-pri Btn-sm mr-lg-3 mb-3 mb-lg-0"
            onClick={this.editButtonHandler}
            type="button"
          >
            Cancel
          </Button>

          <Button className="Btn Btn--pri Btn-sm" type="submit">
            Save
          </Button>
        </div>
      </Form>
    );
  };

  render() {
    if (!this.state.practiceDetails || !this.state.providerList || !this.state.patientList) {
      return <div />;
    }

    return (
      <div
        className="tw:contents"
        // Adding a test locator here won't work
      >
        <header {...getAutomationDataAttr("PracticePage")}>
          <div className="mx-auto fs-14 my-3 py-2">
            <Link className="" to={adminRoute + "/practice"}>
              <p className="d-inline ml-0">Practices</p>
            </Link>

            <span className="fs-14"> {">"} Practice Details</span>
          </div>

          <h3 className="fs-25 tw:font-bold">{this.state.practiceDetails.name}</h3>
        </header>

        {!this.state.editPracticeDetails && (
          <PracticeDetails
            existingIntakeProviders={this.state.existingIntakeProviders}
            onclick={this.editButtonHandler}
            practiceDetails={this.state.practiceDetails}
            providers={this.state.defaultPCPOptions}
          />
        )}

        {this.state.editPracticeDetails && (
          <DashboardCard2 title="Practice Details">
            <CustomForm
              initialValues={{
                ...PRACTICE_INITIAL_VALUES,
                ...this.state.practiceDetails,
              }}
              onSubmit={this.submitHandler}
              render={this.renderForm}
              validationSchema={PRACTICE_VALIDATION_SCHEMA}
            />
          </DashboardCard2>
        )}

        <ProviderList {...this.props} providerList={this.state.providerList} />

        <PatientsList
          {...this.props}
          group_auth_type="admin"
          patientList={this.state.patientList}
          practiceId={this.props.match.params.practiceId}
        />
      </div>
    );
  }
}

export default connect(null, { setDynamicRouteConfiguration })(Practice);
